<button mat-button (click)="elementClicked(navElement)">
  <img [src]="getFullImagePath(navElement)" class="settings-icon" />
  <h2
    [ngClass]="
      navElement.selected ? 'settings-icon-text-selected' : 'settings-icon-text'
    "
  >
    {{ navElement.title }}
  </h2>
</button>
